import axios from "axios";
import i18n from "../../../i18n";
import { handleHttpErrors } from "../../../modules/http";

import {
  orderType,
  tablePageSizes,
} from "../../ui-library/CustomTable/constants";

// Constants
const SET_HISTORY = "SET_DAILY_TARGET_HISTORY";
const RESET_STATE = "RESET_STATE";
const LOGOUT = "LOGOUT";

// Acessors
const getHistory = (state) => state?.history;
const getTotalItems = (state) => state?.totalItems;
const getSearchedParams = (state) => state?.searchedParams;

// Default state
const initialState = {
  history: [],
  totalItems: null,
  searchedParams: {
    page: 0,
    limit: tablePageSizes[0],
    search: "",
    orderBy: "date",
    order: orderType.DESC,
  },
};

export const dailyTargetsHistoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_HISTORY:
      const { data } = action;
      return {
        ...state,
        history: data.data,
        totalItems: data.records,
        searchedParams: action.searchedParams,
      };
    case RESET_STATE:
      return initialState;
    case LOGOUT:
      return initialState;
    default:
      return state;
  }
};

const fetchDailyTargetHistory =
  (dailyTargetId, searchParameters) => async (dispatch) => {
    const params = {
      ...searchParameters,
      dailyTargetId: dailyTargetId,
    };

    return axios
      .get(`/api/diet/dailytarget/history`, { params })
      .then(({ data }) => {
        dispatch({
          type: SET_HISTORY,
          data: data,
          searchedParams: searchParameters,
        });
      })
      .catch((error) => {
        return handleHttpErrors(error.request?.status, {
          default: i18n.t("errorText.dietDiary.dailyTargets.get"),
        });
      });
  };

export const resetState = () => (dispatch) => {
  dispatch({ type: RESET_STATE });
};

export const mapStateToProps = (state) => {
  return {
    history: getHistory(state),
    totalItems: getTotalItems(state),
    searchedParams: getSearchedParams(state),
  };
};

export const mapDispatchToProps = {
  fetchDailyTargetHistory,
  resetState,
};
